import { useQuery } from '@apollo/client';
import { useAddWidget } from '@components/create-widget/useAddWidget';
import useCustomNavigate from '@components/hooks/useCustomNavigate';
import useRoute from '@hooks/useRoute';
import { GET_WIDGET } from '@modules/widgets/api/GetWidget';
import { ILineWidgetModalProps } from '@modules/widgets/forms/LineWidgetModal';
import { WIDGETS_ENUM } from '@utils/widgetTypes';
import { IFormValues, validationSchema } from '../constants/formik';

const useForm = ({ onResolve, widget, isEdit, group, name: nameProps }: ILineWidgetModalProps) => {
  const { createWidgetFn, updateWidget, isLoading } = useAddWidget({
    group,
    widgetType: WIDGETS_ENUM.REACTION_BUTTON,
    cb: () => {},
  });

  const { data, loading: loadingWidgets } = useQuery(GET_WIDGET, {
    variables: { objId: widget?.id },
    fetchPolicy: 'cache-first',
  });

  const getPropValue = (prop) => data?.object?.objectProperties?.find((obj) => obj.key === prop)?.value;
  const navigate = useCustomNavigate();
  const { entityId } = useRoute();

  const formik = {
    initialValues: {
      name: isEdit ? data?.object?.name : nameProps,
      style: isEdit ? getPropValue('settingsStyle') : 'lightondark',
      size: isEdit ? getPropValue('settingsSize') : 'small',
      settingsActionName: isEdit ? getPropValue('settingsActionName') : '',
      description: isEdit ? data?.object?.description : '',
    },
    validationSchema,
    onSubmit: ({ style, size, name, description, settingsActionName }: IFormValues) => {
      if (isEdit) {
        void updateWidget({
          values: {
            settingsStyle: style,
            settingsSize: size,
            settingsActionName,
          },
          defaultValues: {
            settingsSize: '',
          },
          id: widget?.id,
          name,
          description,
          cb: () => {
            onResolve();
          },
        });
      } else {
        void createWidgetFn({
          values: {
            settingsStyle: style,
            settingsSize: size,
            settingsActionName,
          },
          name,
          description,
          cb: (e) => {
            const id = e?.data?.createObjectWithProperties?.uuid as string;
            if (id) navigate(`/boards/${entityId()}/${group?.id}/${id}`);
            onResolve();
          },
        });
      }
    },
  };

  return { formik: isEdit ? data && formik : formik, isLoading: isLoading || loadingWidgets };
};

export default useForm;
